export default new class IngredientsSlider {
  constructor () {
    this.slider = []
    this.init()
  }
  init () {
    document.addEventListener('DOMContentLoaded', () => {
      this.addEventSlider()

    })
  }
  addEventSlider() {
    const sliders = document.querySelectorAll('.js-ingredients-slider')
    sliders.forEach((slider, key) => {
      this.initSlider(slider.dataset.idSlider)
    })



    this.hideTabs()

  }


  hideTabs() {
    setTimeout(()=> {

      tabsPills.closeTabContent()

    }, 0)
  }
  initSlider(id) {
    const thumbs = new Swiper(`[data-id-slider="${id}"] .js-ingredients-thumbs`, {
      slidesPerView: 1,
      effect: 'fade',
      initialSlide: 1,

    });
    const swiper = new Swiper(`[data-id-slider="${id}"] .js-ingredients-slider-top`, {
      slidesPerView: 1,
      initialSlide: 1,
      pagination: {
        el: document.querySelector(`[data-id-slider="${id}"] .js-ingredients-thumbs-bullets`),
        type: 'bullets',
        bulletActiveClass: 'bullets__item--active',
        bulletClass: 'bullets__item',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '" ><span class="bullets__dot">'+"</span></span>";
        },
      },
    });
    swiper.controller.control = thumbs;
    thumbs.controller.control = swiper;

  }
}
